import { useFeatureFlag } from '~/src/common/services/FeatureFlag';
import { ImageParams } from '~/src/common/typings/image';
import { getImageUrl } from '~/src/common/utils/cloudinary';
import GroceryListBanner from '~/src/screens/GroceryList/GroceryListBanner/GroceryListBanner';

import CategoryGrid from '../CategoryGrid/CategoryGrid';
import Reinsurance from '../Reinsurance/Reinsurance';
import { useNavigationTracking } from '../tracking';
import type * as T from '../types';

import * as S from './layout';

interface Props {
  family: T.Family;
  onMount?: (mounted: boolean) => void;
}

const MegaMenu = ({ family, onMount }: Props) => {
  const { id, images, link, name, categories, banner } = family;
  const imgSrc = !!images.aside && getImageUrl(images.aside, ImageParams.familyAside);

  const isGroceryListActivated = useFeatureFlag('grocery-list');

  // Amplitude
  const { large } = useNavigationTracking();
  const { onClickFamilyImage, onClickFamilyBanner } = large;

  // Configuration de l'affichage
  const hasImage = !!imgSrc;
  const hasBanner = !!banner;

  return (
    <S.Container ref={v => onMount?.(!!v)} $count={categories.length} $hasImage={hasImage}>
      <S.Layout>
        {hasImage && (
          <S.Aside href={link || '#'} aria-disabled={!link} onClick={() => onClickFamilyImage(id)}>
            <img src={imgSrc} alt={name} />
          </S.Aside>
        )}
        <S.Body>
          <CategoryGrid categories={categories} />
        </S.Body>
        {isGroceryListActivated ? (
          <S.Footer>
            <GroceryListBanner source="stalls" />
          </S.Footer>
        ) : hasBanner ? (
          <S.Footer>
            <Reinsurance
              onClick={() => onClickFamilyBanner(id)}
              title={banner.title}
              text={banner.text}
              icon={banner.icon}
              link={banner.link}
            />
          </S.Footer>
        ) : null}
      </S.Layout>
    </S.Container>
  );
};

export default MegaMenu;
